import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import api from "../services/api";
import AuthContext from "../contexts/AuthContext";
import ToastContext from "../contexts/ToastContext";

function Editais() {
  const [editais, setEditais] = useState([]);
  const [anexos, setAnexos] = useState({});
  const { user } = useContext(AuthContext);
  const { addToast } = useContext(ToastContext);
  const navigate = useNavigate();

  useEffect(() => {
    async function fetchEditais() {
      try {
        const { data } = await api.get("/editais");
        setEditais(data); // O back-end já filtra os editais ativos
        // Busca os anexos para cada edital
        data.forEach((edital) => fetchAnexos(edital.id));
      } catch (error) {
        addToast("Erro ao buscar editais.", "error");
      }
    }
    fetchEditais();
  }, [addToast]);

  const fetchAnexos = async (editalId) => {
    try {
      const { data } = await api.get(`/anexos-edital/edital/${editalId}`);
      setAnexos((prev) => ({ ...prev, [editalId]: data }));
    } catch (error) {
      // Silencioso para não poluir a tela
      console.error("Erro ao buscar anexos", error);
    }
  };

  const getPeriodoStatus = (edital) => {
    const agora = new Date();
    const inicio = edital?.data_inicio_inscricao
      ? new Date(edital.data_inicio_inscricao)
      : null;
    const fim = edital?.data_fim_inscricao
      ? new Date(edital.data_fim_inscricao)
      : null;

    if (inicio && agora < inicio) {
      return "antes";
    }

    if (fim && agora > fim) {
      return "depois";
    }

    return "ativo";
  };

  const handleInscricaoClick = (edital) => {
    const periodoStatus = getPeriodoStatus(edital);

    if (periodoStatus === "antes") {
      addToast(
        "As inscrições ainda não começaram para este edital.",
        "info"
      );
      return;
    }

    if (periodoStatus === "depois") {
      addToast(
        "O período de inscrições para este edital já foi encerrado.",
        "warning"
      );
      return;
    }

    if (!user.rg || !user.cep || !user.endereco) {
      addToast(
        "Por favor, complete seu cadastro antes de se inscrever.",
        "info"
      );
      navigate("/perfil");
    } else {
      navigate(`/inscrever/${edital.id}`);
    }
  };

  return (
    <div className="container">
      <h1>Editais Abertos</h1>
  <div className="stack-lg section-spacing">
        {editais.length > 0 ? (
          editais.map((edital) => (
            <div key={edital.id} className="surface-section edital-card">
              <h2>
                {edital.nome_edital} - Edital Nº {edital.numero_edital}/
                {edital.ano_edital}
              </h2>
              <p>{edital.descricao}</p>
              <p>
                <strong>Inscrições:</strong>{" "}
                {new Date(edital.data_inicio_inscricao).toLocaleString()} até {new Date(edital.data_fim_inscricao).toLocaleString()}
              </p>
              {anexos[edital.id] && anexos[edital.id].length > 0 && (
                <div>
                  <strong>Anexos:</strong>
                  <ul className="attachment-list">
                    {anexos[edital.id].map((anexo) => (
                      <li key={anexo.id} className="attachment-item">
                        <a
                          href={`${process.env.REACT_APP_API_URL}/../uploads/${anexo.caminho_arquivo}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="attachment-name"
                        >
                          {anexo.nome_arquivo}
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
              {(() => {
                const periodoStatus = getPeriodoStatus(edital);
                const inicio = edital.data_inicio_inscricao
                  ? new Date(edital.data_inicio_inscricao)
                  : null;
                const fim = edital.data_fim_inscricao
                  ? new Date(edital.data_fim_inscricao)
                  : null;
                const inscricaoBloqueada = periodoStatus !== "ativo";

                const hintMessage =
                  periodoStatus === "antes" && inicio
                    ? `Inscrições abrem em ${inicio.toLocaleString()}`
                    : periodoStatus === "depois" && fim
                    ? `Inscrições encerradas em ${fim.toLocaleString()}`
                    : null;

                return (
                  <div
                    className={`inscricao-actions ${
                      inscricaoBloqueada ? "inscricao-actions--bloqueada" : ""
                    }`}
                  >
                    <button
                      type="button"
                      onClick={() => handleInscricaoClick(edital)}
                      className={`btn-modern btn-file ${
                        inscricaoBloqueada ? "btn-blocked" : ""
                      }`}
                      aria-disabled={inscricaoBloqueada}
                    >
                      Inscrever-se
                    </button>
                    {hintMessage && (
                      <span className="inscricao-status-hint">
                        {hintMessage}
                      </span>
                    )}
                  </div>
                );
              })()}
            </div>
          ))
        ) : (
          <p>Nenhum edital aberto no momento.</p>
        )}
      </div>
    </div>
  );
}

export default Editais;
